import { render, staticRenderFns } from "./ingredient-restock.vue?vue&type=template&id=48a95a24&scoped=true&"
import script from "./ingredient-restock.vue?vue&type=script&lang=js&"
export * from "./ingredient-restock.vue?vue&type=script&lang=js&"
import style0 from "./ingredient-restock.vue?vue&type=style&index=0&id=48a95a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a95a24",
  null
  
)

export default component.exports